const FULL_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Short opaque session ids from the API (e.g. "t0742"): letters then digits only.
 * Require digits >= letters and a minimum digit run so values like "test123"
 * still map to user_id search, while "t0742" maps to session_id.
 */
function isCompactSessionIdQuery(q) {
  const m = q.match(/^([a-zA-Z]+)(\d+)$/);
  if (!m) return false;
  const [, letters, digits] = m;
  if (letters.length > 8) return false;
  if (digits.length < 3) return false;
  return digits.length >= letters.length;
}

/**
 * True when the search box value should filter by session_id (not user_id).
 * Covers UUIDs (client ChatSection), sess_* prefixes, hex-like ids, and short
 * backend session codes like "t0742".
 */
export function isSessionIdSearchQuery(query) {
  const q = (query || "").trim();
  if (!q) return false;
  if (q.startsWith("sess_")) return true;
  if (FULL_UUID_RE.test(q)) return true;
  if (isCompactSessionIdQuery(q)) return true;
  if (/^[0-9a-f-]+$/i.test(q)) {
    if (q.includes("-")) return q.replace(/-/g, "").length >= 4;
    return q.length >= 8;
  }
  return false;
}

/** Map admin list search text to session_id or user_id query params. */
export function applyAdminSearchParams(params, searchId) {
  const query = (searchId || "").trim();
  if (!query) return params;
  if (isSessionIdSearchQuery(query)) {
    params.session_id = query;
  } else {
    params.user_id = query;
  }
  return params;
}

/** Client-side fallback when the API returns an unfiltered page. */
export function filterAdminListBySearch(
  items,
  searchId,
  fields = ["session_id", "user_id"]
) {
  if (!Array.isArray(items)) return [];
  const query = (searchId || "").trim().toLowerCase();
  if (!query) return items;
  return items.filter((item) =>
    fields.some((field) =>
      String(item?.[field] ?? "")
        .toLowerCase()
        .includes(query)
    )
  );
}
